import { FormikValues } from 'formik'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'

import { Button } from 'components/button'
import { Form } from 'components/form'
import { Modal, ModalHeader } from 'components/modal'
import { Select } from 'components/select'
import { TextInput } from 'components/textInput'

import { GlobalState } from 'store'
import { updateUserRole } from 'store/institution/actions'
import { closeModal } from 'store/modal/actions'

import { ModalName } from 'types/enums/ModalName'
import { UserRole } from 'types/enums/UserRole'

import { ModalBody } from './styled'

type Props = {
  initialValues: FormikValues
}

export function InstitutionEditMemberModal({
  initialValues
}: Props): JSX.Element {
  const { t } = useTranslation(['modal', 'common'])

  const dispatch = useDispatch()

  const {
    modal: { institutionEditMemberIsOpen },
    institution: { updateUserRoleInProgress }
  } = useSelector((state: GlobalState) => state)

  const validationSchema = Yup.object().shape({
    cnpj: Yup.string().required('required'),
    email: Yup.string().email('email').required('required'),
    role: Yup.string().required('required')
  })

  useEffect(() => {
    if (!institutionEditMemberIsOpen) {
      const resetForm = document.getElementById('resetForm')
      if (resetForm) resetForm.click()
    }
  }, [institutionEditMemberIsOpen])

  function _handleSubmit(data: FormikValues) {
    dispatch(
      updateUserRole({
        cnpj: data.cnpj,
        email: data.email,
        role: data.role
      })
    )
  }

  return (
    <Modal
      width="650px"
      isOpen={institutionEditMemberIsOpen}
      onClose={() => dispatch(closeModal(ModalName.INSTITUTION_EDIT_MEMBER))}
    >
      <ModalHeader separator={false}>
        <h2>{t('modal:institutionEditMember.title')}</h2>
      </ModalHeader>

      <ModalBody>
        <Form
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => _handleSubmit(values)}
        >
          <TextInput
            label="CNPJ"
            name="cnpj"
            placeholder={t('modal:institutionEditMember.form.cnpj')}
            disabled
          />

          <TextInput
            label="EMAIL"
            isEmail={true}
            name="email"
            placeholder={t('modal:institutionEditMember.form.email')}
            disabled
          />

          <Select
            label="ATRIBUIÇÃO"
            name="role"
            placeholder={t('modal:institutionEditMember.form.role')}
            options={[
              {
                label: t('common:userRoles.EDIT'),
                value: UserRole.EDIT
              },
              {
                label: t('common:userRoles.READ'),
                value: UserRole.READ
              }
            ]}
          />

          <Button
            backgroundColor="primary"
            fullWidth
            small
            type="submit"
            inProgress={updateUserRoleInProgress}
          >
            {t('modal:institutionEditMember.form.submitButton')}
          </Button>
        </Form>
      </ModalBody>
    </Modal>
  )
}
